<template>
  <div
    class="menu_box"
    :style="{
      height: content.textStyle.height + 'rem' || '',
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: content.textStyle.fontSize + 'rem' || '',
      lineHeight: content.textStyle.lineHeight + 'rem' || '',
      maxWidth: content.textStyle.maxWidth + 'rem' || '',
      textIndent:
        content.textStyle.textIndent &&
        typeof content.textStyle.textIndent === 'string'
          ? content.textStyle.textIndent
          : content.textStyle.textIndent &&
            typeof content.textStyle.textIndent === 'number'
          ? content.textStyle.textIndent + 'rem'
          : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage
        ? `url(${content.textStyle.backgroundImage})`
        : '',
      padding: '0 20rem',
    }"
    @click="expandRowClick(content)"
  >
    <span class="menu_title">{{ content.text }}</span>
    <img
      class="menu_arrow"
      :src="
        !content.isexpand
          ? require('@/assets/images/books/book2/retract.png')
          : require('@/assets/images/books/book2/expend.png')
      "
      alt=""
    />
    <pdfPreview ref="pdfPreview" :dialogVisible="dialogVisible" :dialogContent="dialogContent" @dialogClose="dialogClose"></pdfPreview>
  </div>
</template>
   
<script>
import pdfPreview from "../mixPopup/pdfPreview.vue";
export default {
  data() {
    return {
        dialogVisible:false,
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    pdfPreview,
  },
  created() {},
  methods: {
    expandRowClick(content) {
        this.content.isexpand = !this.content.isexpand;
        //显示预览pdf弹窗
        // this.dialogVisible = true;
        // this.dialogContent = content;
    },
    changeExpand() {
      this.content.isexpand = !this.content.isexpand;
    },
    dialogClose(){
        this.dialogVisible = false;
    }
  },
};
</script>
   
<style scoped lang='scss'>
.menu_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  cursor: pointer;
  .menu_title {
    width: 95%;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }
  .menu_arrow {
    width: 22rem;
    height: 22rem;
  }
}
</style>